import { render, staticRenderFns } from "./OrdersInboundDetailUser.vue?vue&type=template&id=2221cea4&scoped=true"
import script from "./OrdersInboundDetailUser.vue?vue&type=script&lang=js"
export * from "./OrdersInboundDetailUser.vue?vue&type=script&lang=js"
import style0 from "./OrdersInboundDetailUser.vue?vue&type=style&index=0&id=2221cea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2221cea4",
  null
  
)

export default component.exports